import React, { useEffect, useState } from 'react';
import { Table, Button, Popconfirm, Space, Input, Select, Row, Col } from 'antd';
import AppLayout from '../../components/AppLayout';


const EmployeeList: React.FC = () => {
  const [employees, setEmployees] = useState<any[]>([]);
  const [filteredEmployees, setFilteredEmployees] = useState<any[]>([]);
  const [filters, setFilters] = useState({ name: '', department: '', status: '' });

  useEffect(() => {
    const demoEmployees = Array.from({ length: 50 }, (_, i) => ({
      id: i + 1,
      name: `Employee ${i + 1}`,
      email: `employee${i + 1}@company.com`,
      department: ['HR', 'Sales', 'Development', 'Support'][i % 4],
      status: ['Active', 'Inactive'][i % 2],
    }));
    setEmployees(demoEmployees);
    setFilteredEmployees(demoEmployees);
  }, []);

  const handleFilterChange = (field: string, value: string) => {
    const newFilters = { ...filters, [field]: value };
    setFilters(newFilters);
    const result = employees.filter(emp =>
      (newFilters.name === '' || emp.name.toLowerCase().includes(newFilters.name.toLowerCase())) &&
      (newFilters.department === '' || emp.department === newFilters.department) &&
      (newFilters.status === '' || emp.status === newFilters.status)
    );
    setFilteredEmployees(result);
  };

  const columns = [
    { title: 'Name', dataIndex: 'name', key: 'name' },
    { title: 'Email', dataIndex: 'email', key: 'email' },
    { title: 'Department', dataIndex: 'department', key: 'department' },
    { title: 'Status', dataIndex: 'status', key: 'status' },
    {
      title: 'Actions',
      key: 'actions',
      render: (_:any, record:any) => (
        <Space>
          <Button type="link">Edit</Button>
          <Popconfirm title="Sure to delete?" onConfirm={() => console.log('Delete', record.id)}>
            <Button danger type="link">Delete</Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <AppLayout>
      <Row gutter={16} style={{ marginBottom: 16 }}>
        <Col span={8}>
          <Input
            placeholder="Search Name"
            value={filters.name}
            onChange={(e) => handleFilterChange('name', e.target.value)}
          />
        </Col>
        <Col span={8}>
          <Select
            placeholder="Filter by Department"
            value={filters.department}
            onChange={(value) => handleFilterChange('department', value)}
            allowClear
            style={{ width: '100%' }}
          >
            <Select.Option value="HR">HR</Select.Option>
            <Select.Option value="Sales">Sales</Select.Option>
            <Select.Option value="Development">Development</Select.Option>
            <Select.Option value="Support">Support</Select.Option>
          </Select>
        </Col>
        <Col span={8}>
          <Select
            placeholder="Filter by Status"
            value={filters.status}
            onChange={(value) => handleFilterChange('status', value)}
            allowClear
            style={{ width: '100%' }}
          >
            <Select.Option value="Active">Active</Select.Option>
            <Select.Option value="Inactive">Inactive</Select.Option>
          </Select>
        </Col>
      </Row>
      <Table
        dataSource={filteredEmployees}
        columns={columns}
        rowKey="id"
        pagination={{ pageSize: 10 }}
      />
    </AppLayout>
  );
};

export default EmployeeList;